// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__27wp9","inner":"Footer_inner__CfIvo"};